"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeededCryptoModulePromise = void 0;
/// <reference types="emscripten" />
const SeededCryptoModuleNotReallyAPromiseFn = require("./seeded-crypto-js");
const webasm_module_memory_helper_1 = require("@dicekeys/webasm-module-memory-helper");
__exportStar(require("./seeded-crypto-object-fields"), exports);
;
;
;
;
/**
 * This typing exists to ensure that pointers from other webassembly modules
 * are not accidentally passed into this webassembly module.
 *
 * @category Parameter Passing
 */
var PtrIntoSeededCryptoModule;
(function (PtrIntoSeededCryptoModule) {
    PtrIntoSeededCryptoModule[PtrIntoSeededCryptoModule["_"] = 0] = "_";
})(PtrIntoSeededCryptoModule || (PtrIntoSeededCryptoModule = {}));
{
}
/**
 * Import and await this value to get access to the module's API, ensuring that the
 * runtime has downloaded the underlying WebAssembly code and compiled it before
 * any operations are called.
 *
 * @category Module Access
 */
exports.SeededCryptoModulePromise = webasm_module_memory_helper_1.getWebAsmModulePromiseWithAugmentedTypes(SeededCryptoModuleNotReallyAPromiseFn());
//# sourceMappingURL=seeded-crypto.js.map